export default {
  getBites: state => state.bitesList,
  getLotWithMaterialItems: state => state.lotWithMaterialItems,
  getLotWithMaterialItemsCount: state => state.lotWithMaterialItemsCount,
  getDiagnosisGroups: state => state.diagnosisGroupsList,
  getDiagnosis: state => state.diagnosis,
  getDiagnosisCount: state => state.diagnosisCount,
  getPlans: state => state.plansList,
  getPlansCount: state => state.plansCount,
  getServicesGroupsMain: state => state.servicesGroupsMain,
  getServicesGroups: state => state.servicesGroups,
  getServicesGroupsAll: state => state.servicesGroupsAll,
  getDiagnosisGroupsMain: state => state.diagnosisGroupsMain,
  getDiagnosisSubGroups: state => state.diagnosisSubGroups,
  getDiagnosisGroupsAll: state => state.diagnosisGroupsAll,
  getMaterialGroups: state => state.materialGroups,
  detailedMaterialsGroupsInfo: state => state.detailedMaterialsGroupsInfo,
  materialsPerPage: state => state.materialsPerPage,
  materialsPerPageCount: state => state.materialsPerPageCount,
  getMaterialLotsPerPage: state => state.materialLotsPerPage,
  getMaterialLotsPerPageTotalCount: state => state.materialLotsPerPageCount,
  roleList: state => state.roles,
  getDiscount: state => id => {
    return state.discountCardsList.find(d => d.id === id)
  },
  getDentalServices: state => state.services,
  getDentalServicesCount: state => state.servicesCount,
  getServiceById: state => id => state.services.find(s => s.id === id),
  abilities: state => state.abilities,
  integrators: state => state.integrators,
  integratorsForDropdown: state => state.integratorsForDropdown,
  serviceTimes: state => state.serviceTimes,
  serviceTimesCount: state => state.serviceTimesCount,
  patientTypes: state => state.patientTypes,
  findIntegrator: state => id => {
    return state.integrators.find(i => i.id === id) || null
  },
  integratorsCount: state => state.integratorsCount,
  integratorTypeOptions: state => state.integratorTypeOptions,
  integratorATEOptions: state => state.integratorATEOptions,
  employeeDeductionAmountTypeOptions: state => state.employeeDeductionAmountTypeOptions,
  patientTypesCount: state => state.patientTypesCount,
  integrator: state => state.integrator,
  integratorSettings: state => state.integratorSettings,
  patientType: state => state.patientType,
  employee: state => state.employee,
  permissions: state => state.permissions,
  getEmployeeByClinicPerPage: state => state.employeeByClinicPerPage,
  getEmployeeByClinicPerPageCount: state => state.employeeByClinicPerPageCount,
  getContactsFrom: state => state.contactsFromList,
  getContactFrom: state => state.contactFrom,
  getPaymentMethodExtendedCategories: state => state.paymentMethodExtendedCategories,
  getPaymentDirections: state => state.paymentDirections,
  getPaymentDirectionTypes: state => state.paymentDirectionTypes,
  getServiceTypes: state => state.serviceTypes,
  getDiscountCards: state => state.discountCardsList,
  paymentMethods: state => state.paymentMethods,
  advisoryOpinions: state => state.advisoryOpinions,
  advisoryOpinionsCount: state => state.advisoryOpinionsCount,
  insuranceCompaniesForDropdown: state => state.insuranceCompaniesForDropdown,
  insuranceCompanies: state => state.insuranceCompanies,
  insuranceCompaniesCount: state => state.insuranceCompaniesCount,
  getSearchTemplates: state => state.searchTemplates,
  getSearchTemplatesCount: state => state.searchTemplatesCount,
  getNotificationConditionCategoriesPerPage: state => state.notificationConditionCategoriesPerPage,
  getNotificationConditionCategoriesTotalCount: state => state.notificationConditionCategoriesTotalCount,
  getNotificationConditionCategories: state => state.notificationConditionCategories,
  getLegalPersons: state => state.legalPersons,
  getLegalPersonsCount: state => state.legalPersonsCount,
  thirdPartyOrganizations: state => state.thirdPartyOrganizations,
  thirdPartyOrganizationsForDropdown: state => state.thirdPartyOrganizationsForDropdown,
  thirdPartyOrganizationsCount: state => state.thirdPartyOrganizationsCount,
  getPatientAppealResultsPerPage: state => state.patientAppealResultsPerPage,
  getPatientAppealResultsCount: state => state.patientAppealResultsCount,
  getPatientAppealResults: state => state.patientAppealResults,
  getContacts: state => state.contacts,
  getPhysicianProtocolFields: state => state.physicianProtocolFields,
  getPhysicianProtocolFieldValues: state => state.physicianProtocolFieldValues,
  getPhysicianProtocolSections: state => state.physicianProtocolSections,
  getPhysicianProtocolSubsections: state => state.physicianProtocolSubsections,
  getPhysicianProtocolPerPage: state => state.physicianProtocolPerPage,
  getPhysicianProtocolPerPageCount: state => state.physicianProtocolPerPageCount,
  getAnalysesSynevoPerPage: state => state.analysesSynevoPerPage,
  getAnalysesSynevoPerPageCount: state => state.analysesSynevoPerPageCount,
  patientCardTemplateMainGroups: state => state.patientCardTemplateMainGroups,
  getPatientCardTemplateGroups: state => state.patientCardTemplateGroups,
  getTreatmentFeaturesPerPage: state => state.treatmentFeaturesPerPage,
  getTreatmentFeaturesPerPageCount: state => state.treatmentFeaturesPerPageCount,
  getTreatmentFeaturesForDropdown: state => state.treatmentFeaturesForDropdown,
  getPlansWithTimePerPage: state => state.plansWithTimePerPage,
  getPlansWithTimePerPageCount: state => state.plansWithTimePerPageCount,
  getDentalServicesWithTimePerPage: state => state.dentalServicesWithTimePerPage,
  getDentalServicesWithTimePerPageCount: state => state.dentalServicesWithTimePerPageCount,
  getUserServiceForTimePropertyPerPage: state => state.userServiceForTimePropertyPerPage,
  getUserServiceForTimePropertyPerPageCount: state => state.userServiceForTimePropertyPerPageCount,
  getUserDentalServicePropertyPerPage: state => state.userDentalServicePropertyPerPage,
  getUserDentalServicePropertyPerPageCount: state => state.userDentalServicePropertyPerPageCount,
  getUserTreatmentPlanPropertyPerPage: state => state.userTreatmentPlanPropertyPerPage,
  getUserTreatmentPlanPropertyPerPageCount: state => state.userTreatmentPlanPropertyPerPageCount,
  getUserActivityLogItemsPerPage: state => state.userActivityLogItemsPerPage,
  getUserActivityLogItemsPerPageCount: state => state.userActivityLogItemsPerPageCount,
  getPricingTypeGroups: state => state.pricingTypeGroups,
  getPricingTypeGroupItems: state => state.pricingTypeGroupItems,
  getMaterialUnitTypes: state => state.units,
  getNds: state => state.nds,
  getMaterialLotTypes: state => state.materialLotTypes,
  getPatientAppointmentStatuses: state => state.patientAppointmentStatuses,
  getPatientAppointmentStatusesPerPage: state => state.patientAppointmentStatusesPerPage,
  getPatientAppointmentStatusesPerPageCount: state => state.patientAppointmentStatusesPerPageCount,
  patientAppointmentStatusSettings: state => state.patientAppointmentStatusSettings,
  getTimezones: state => state.timeZones,
  getPatientContactViewPasswordSendingMethods: state => state.patientContactViewPasswordSendingMethods,
  getAppointmentNotificationOnCustomDayOptions: state => state.appointmentNotificationOnCustomDayOptions,
  getAppointmentNotificationByLastAppointmentOptions: state => state.appointmentNotificationByLastAppointmentOptions,
  getAppointmentNotificationByGenderOptions: state => state.appointmentNotificationByGenderOptions,
  getFaqQuestions: state => state.faqQuestions,
  serviceTypesForDropdown: state => state.serviceTypesForDropdown,
  medicalServiceTypePerPage: state => state.medicalServiceTypePerPage,
  medicalServiceTypePerPageCount: state => state.medicalServiceTypePerPageCount,
  specialistTypes: state => state.specialistTypes,
  specialistTypesPerPage: state => state.specialistTypesPerPage,
  specialistTypesPerPageCount: state => state.specialistTypesPerPageCount,
  dentalServiceSpecialistTypePerPage: state => state.dentalServiceSpecialistTypePerPage,
  dentalServiceSpecialistTypePerPageCount: state => state.dentalServiceSpecialistTypePerPageCount,
  materialPriceList: state => state.materialPriceList,
  materialPriceListItems: state => state.materialPriceListItems,
  materialPriceListItemsCount: state => state.materialPriceListItemsCount,
  onlineAppointmentServiceTimeIntervals: state => state.onlineAppointmentServiceTimeIntervals,
  integratorBranchesPerPage: state => state.integratorBranchesPerPage,
  integratorBranchesPerPageCount: state => state.integratorBranchesPerPageCount,
  materialPriceCalcSystem: state => state.materialPriceCalcSystem,
  recommendedVisitTypesForDropdown: state => state.recommendedVisitTypesForDropdown,
  recommendedVisitTypes: state => state.recommendedVisitTypes,
  recommendedVisitTypesCount: state => state.recommendedVisitTypesCount,
  specialistTypeWageDeductionsAmountPerPage: state => state.specialistTypeWageDeductionsAmountPerPage,
  specialistTypeWageDeductionsAmountPerPageCount: state => state.specialistTypeWageDeductionsAmountPerPageCount,
  counterparties: state => state.counterparties,
  counterpartiesCount: state => state.counterpartiesCount,
  teethStates: state => state.teethStates,
  teethStatesCount: state => state.teethStatesCount,
  toothStateServicesPerPage: state => state.toothStateServicesPerPage,
  toothStateServicesPerPageCount: state => state.toothStateServicesPerPageCount,
  toothStateComplexesPerPage: state => state.toothStateComplexesPerPage,
  toothStateComplexesPerPageCount: state => state.toothStateComplexesPerPageCount,
  servicesRecalculationProcessIsActive: state => state.servicesRecalculationProcessIsActive,
}
